import { inject, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser } from '../state/user.reducer';

@Injectable({
  providedIn: 'root'
})
export class FeatueFlagsService {

  private user$: Subscription
  private featureFlags: string[] = []
  private store = inject<Store<any>>(Store)

  constructor() {
    this.user$ = this.store.select(selectUser).subscribe(u => this.featureFlags = u?.featureFlags ?? [])
  }

  getFeatureFlags() : string[] {
    return this.featureFlags
  }

  hasFeatureFlag(flagName: string) : boolean  {
    return this.featureFlags.includes(flagName)
  }
}
